import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = {
  class: "menu menu-sub menu-sub-dropdown w-300px w-md-350px",
  "data-kt-menu": "true"
}
const _hoisted_9 = { class: "px-7 py-5" }
const _hoisted_10 = { class: "fs-5 text-dark fw-bold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_12 = { class: "px-7 py-5" }
const _hoisted_13 = { class: "form-label mb-3" }
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = { class: "px-7 py-5" }
const _hoisted_16 = { class: "form-label mb-3" }
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tabla.profesionalesListado.titulo")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("tabla.profesionalesListado.numeroProfesionales", {
                numero: _ctx.profesionalesListado.length,
              })), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  class: "me-5",
                  modelValue: _ctx.selectedComarcaId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedComarcaId) = $event)),
                  filterable: "",
                  clearable: "",
                  style: {"width":"300px"},
                  loading: _ctx.loadingComarcas,
                  placeholder: _ctx.$t('tabla.familias.cabecera.comarca'),
                  key: _ctx.comarcaSelectKey,
                  onVisibleChange: _ctx.onComarcaVisibleChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (c) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: c.id,
                        label: c.nombre,
                        value: c.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "placeholder", "onVisibleChange"]))
              : _createCommentVNode("", true),
            _createElementVNode("button", _mergeProps({
              type: "button",
              class: "btn btn-light-primary position-relative me-5"
            }, _ctx.$attrs, {
              "data-kt-menu-trigger": "click",
              "data-kt-menu-placement": "bottom-end",
              "data-kt-menu-flip": "top-end"
            }), [
              _createElementVNode("span", _hoisted_7, [
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("grids.filterButton")) + " ", 1),
              (_ctx.localidad !== undefined && _ctx.localidad !== '')
                ? (_openBlock(), _createBlock(_component_el_badge, {
                    key: 0,
                    "is-dot": ""
                  }))
                : _createCommentVNode("", true)
            ], 16),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("grids.filter.header")), 1)
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("tabla.familiasListado.filtro.municipio")) + ": ", 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.localidad,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localidad) = $event)),
                    name: "localidad",
                    filterable: "",
                    placeholder: _ctx.$t('OpcionInicialLocalidad'),
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        disabled: "",
                        value: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("OpcionInicialLocalidad")), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipiosComarca, (municipio, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          value: municipio.municipioNombre,
                          class: _normalizeClass({
                      'bg-light-primary':
                        _ctx.localidad === municipio.municipioNombre,
                    })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(municipio.municipioNombre), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "localidad",
                  class: "fv-plugins-message-container invalid-feedback"
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("Solicitud para trabajar")) + ": ", 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.disponibleComarca,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.disponibleComarca) = $event)),
                    name: "disponibleComarca",
                    filterable: "",
                    placeholder: _ctx.$t('OpcionInicialLocalidad'),
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        disabled: "",
                        value: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("OpcionInicialLocalidad")), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcasFiltro, (comarca, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          value: comarca.id,
                          label: comarca.text,
                          class: _normalizeClass({
                      'bg-light-primary': _ctx.disponibleComarca === comarca.id,
                    })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(comarca.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "disponibleComarca",
                  class: "fv-plugins-message-container invalid-feedback"
                })
              ])
            ]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
              style: {"width":"300px"},
              placeholder: _ctx.$t('tabla.buscador.placeholder')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_download_excel, {
              data: _ctx.profesionalesListado,
              labels: _ctx.csvLabels,
              fields: _ctx.csvFields,
              name: _ctx.csvName
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_18, [
                  _createElementVNode("i", {
                    class: "fas fa-file-excel fs-3",
                    title: _ctx.$t('tabla.profesionalesListado.boton.imprimir')
                  }, null, 8, _hoisted_19)
                ])
              ]),
              _: 1
            }, 8, ["data", "labels", "fields", "name"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _ctx.result,
            style: {"width":"100%"},
            stripe: "",
            "default-sort": { prop: 'createdOn', order: 'descending' },
            onSortChange: _ctx.sortChange
          }, {
            default: _withCtx(() => [
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: _ctx.$t('tabla.familias.cabecera.comarca'),
                    prop: "nombreComarca",
                    sortable: "",
                    "min-width": "150"
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.nombre'),
                prop: "nombreCompleto",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.dni'),
                prop: "dni",
                sortable: "",
                width: "120"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.email'),
                prop: "email",
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.telefono'),
                prop: "telefono",
                sortable: "",
                width: "120"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.localidad'),
                prop: "localidad",
                sortable: "",
                "min-width": "120"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.carnetConducir'),
                sortable: "",
                width: "90"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.carnetConducir
                  ? _ctx.$t("tabla.profesionalesListado.fila.carnetSi")
                  : _ctx.$t("tabla.profesionalesListado.fila.carnetNo")), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.profesionalesListado.cabecera.vehiculo'),
                sortable: "",
                width: "110"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.vehiculo && scope.row.vehiculo !== "NO"
                  ? _ctx.$t("tabla.profesionalesListado.fila.vehiculoSi")
                  : _ctx.$t("tabla.profesionalesListado.fila.vehiculoNo")), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                width: "50",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "text",
                    onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("tabla.profesionalesListado.fila.ver")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSortChange"])), [
            [_directive_loading, _ctx.cargaListado]
          ]),
          _createVNode(_component_el_pagination, {
            class: "my-5 float-end",
            background: "",
            "page-size": 100,
            layout: "prev, pager, next",
            total: _ctx.profesionalesListado.length,
            "hide-on-single-page": true,
            "current-page": _ctx.currentPage,
            onCurrentChange: _ctx.handleCurrentPageChange
          }, null, 8, ["total", "current-page", "onCurrentChange"])
        ])
      ])
    ]),
    _: 3
  }))
}